module.exports = __webpack_public_path__ + "2238e7a54066a5846a1b8d6732eabd4a.otf";